<mat-card appearance="outlined" [ngClass]="{ outline: appearance === 'outline' }">
  <mat-card-header>
    <mat-card-title>
      <span>{{ 'FRONTEND.FORMS.SPECIAL_HOURS.TITLE' | translate }}</span>
      <button
        mat-icon-button
        type="button"
        [color]="'primary'"
        (click)="openEditDialog()"
        [disabled]="control.disabled"
      >
        <mat-icon>mode_edit</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <ng-container *ngIf="(loading$ | async) === false; else loading">
    <ng-container
      *ngIf="getSpecialDateTime().length === 0; then displayEmptySpecialHours; else displaySpecialHours"
    ></ng-container>
    <ng-template #displayEmptySpecialHours>
      <mat-card-content class="business-hours__empty-hours">
        <span>
          <img
            src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/listing-profile-special-hours-empty.svg"
            alt="Empty Special Hours"
          />
        </span>
        <span>{{ 'FRONTEND.FORMS.SPECIAL_HOURS.DESCRIPTION_ADD_EXCEPTIONS' | translate }}</span>
      </mat-card-content>
    </ng-template>
    <ng-template #displaySpecialHours>
      <mat-card-content *ngFor="let specialDateTime of getSpecialDateTime()" class="business-hours__hours">
        <forms-special-hours-display
          [control]="control"
          [specialDateTimeSpan]="specialDateTime"
        ></forms-special-hours-display>
      </mat-card-content>
    </ng-template>
  </ng-container>
</mat-card>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
